import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DirectivesModule } from '../directives/directives.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GeneralModule } from '../general/general.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MaterialModule } from '../../material.module';
import { MomentModule } from 'ngx-moment';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { NavbarComponent } from './navbar.component';
import { SearchComponent } from './search.component';
import { BrowseSearchComponent } from './browseSearch.component';
import { CreateTopicLinkComponent } from './createTopicLink.component';
import { ContextNameComponent } from './contextName.component';
import { AppNavigationComponent } from './appNavigation.component';
import { AppRightNavigationComponent } from './appRightNavigation.component';
import { LogoComponent } from './logo.component';

@NgModule({
    imports: [
        CommonModule,
        DirectivesModule,
        FlexLayoutModule,
        FormsModule,
        GeneralModule,
        ReactiveFormsModule,
        HttpClientModule,
        MaterialModule,
        MomentModule,
        RouterModule,
        InfiniteScrollModule,
    ],
    declarations: [
        AppNavigationComponent,
        AppRightNavigationComponent,
        BrowseSearchComponent,
        CreateTopicLinkComponent,
        LogoComponent,
        NavbarComponent,
        SearchComponent,
        ContextNameComponent
    ],
    exports: [
        AppNavigationComponent,
        AppRightNavigationComponent,
        BrowseSearchComponent,
        CreateTopicLinkComponent,
        LogoComponent,
        NavbarComponent,
        ContextNameComponent
    ]
})
export class NavigationModule {
}